import { ANALYSIS_TYPES } from "../../../constants/intxConstants";
import {
  COST_PARAMETERS_STORAGE_KEYS,
  STEP_STORAGE_KEYS,
} from "../../../constants/storageConstants";
import { getAnalysisType } from "../../../util/dataSelectors";
import { OPERATIONS_MAINTENANCE_TYPES } from "./operationsAndMaintenanceHelper";

export const getDiscountRate = (projectData) => {
  const discountRateForm =
    projectData[STEP_STORAGE_KEYS.COST_PARAMETERS_DEFAULTS]?.discountRate;
  return (
    discountRateForm?.discountRate ?? window.PENN_DOT_CONSTANTS.DISCOUNT_RATE
  );
};

export const isCostParametersDefaultsEmpty = (projectData) => {
  const isEmpty = (section = {}) =>
    Object.values(section).every(
      (value) => value === "" || value === undefined || value === null
    );
  return [
    COST_PARAMETERS_STORAGE_KEYS.COST_PER_CRASH,
    COST_PARAMETERS_STORAGE_KEYS.DISCOUNT_RATE,
    COST_PARAMETERS_STORAGE_KEYS.VALUE_OF_TIME,
  ].every((key) =>
    isEmpty(projectData[STEP_STORAGE_KEYS.COST_PARAMETERS_DEFAULTS]?.[key])
  );
};

/**
 * @param {object} projectData
 * @returns true if there are no operations/maintenance costs saved, or if the default values from window are saved
 * returns false if any value has been updated
 */
export const isOpsMaintenanceCostsEmpty = (projectData) => {
  const isRampTerminalIntersection =
    getAnalysisType(projectData) === ANALYSIS_TYPES.RAMP_TERMINAL_INTERSECTION;
  return projectData[STEP_STORAGE_KEYS.INTERSECTIONS].every(
    (intersection = {}) => {
      const costParameters =
        intersection[COST_PARAMETERS_STORAGE_KEYS.COST_PARAMETERS]?.[
          COST_PARAMETERS_STORAGE_KEYS.OPERATIONS_AND_MAINTENANCE
        ];

      return (
        !costParameters ||
        Object.entries(costParameters).every(([key, values]) => {
          if (key.includes("other")) {
            return values.cost === 0;
          }
          const { constantsKey } = OPERATIONS_MAINTENANCE_TYPES.find(
            ({ storageKey }) => storageKey === key
          );
          const defaultValues =
            window.PENN_DOT_CONSTANTS.OPERATIONS_MAINTENANCE_COSTS[
              isRampTerminalIntersection
                ? "RAMP_TERMINAL_INTERSECTION"
                : "AT_GRADE_INTERSECTION"
            ][intersection.type][constantsKey];
          return (
            values?.periodYears === defaultValues?.periodYears &&
            values?.cost === defaultValues?.cost
          );
        })
      );
    }
  );
};
